<template>
    <div v-if="itemSelect" class="mb20">
      <!-- <label class="pages">
      <input type="radio" value="預約資訊" class="page" name="page" v-model="infopage"> -->
      <!-- <input type="radio" value="領隊資訊" class="page" name="page" v-model="infopage"> -->
    <!-- </label> -->
    <template v-if="infopage==='預約資訊'">
    <editBox v-if="!edit" @edit="editInfo">
      <div v-for="(fd, i) in Object.keys(fieldsDetial)" :key="`fd-${i}`" class="infoCol">
        <div>{{fieldsDetial[fd]}}</div>
        <div v-if="fd==='status'" class="預約狀態" :class="itemSelect.status">{{itemSelect.status}}</div>
        <div v-else-if="fd==='visitDate'">{{toDate(itemSelect.visitDate)}}</div>
        <div v-else-if="fd==='agency'">{{itemSelect.agency&&itemSelect.agency?.name}}</div>
        <div v-else-if="fd==='teamAttributes'" :style="{color:'var(--color-checked)', fontWeight: 700}">{{itemSelect.teamAttributes}}</div>
        <div v-else>{{itemSelect[fd] ? itemSelect[fd] : '-'}}</div>
      </div>
      <hr>
      <div class="infofoot">
        <div>接單人員: {{itemSelect.createBy&&(itemSelect.createBy?.name || itemSelect.createBy.LINEName)}}</div>
        <div>{{toDateTime(itemSelect.createTime)}}</div>
      </div>
      <div class="infofoot">
        <div>操作人員: {{itemSelect.operator&&itemSelect.operator?.name}}</div>
        <div>{{toDateTime(itemSelect.updateTime)}}</div>
      </div>
    </editBox>
    <editBox v-else :btnHide="true">
      <div v-for="(fd, i) in Object.keys(fieldsDetial).filter(k => k !== 'agencyID')" :key="`fd-${i}`" class="infoCol infoColEdit">
        <div>{{fieldsDetial[fd]}}</div>
        <div v-if="fd==='status'">
          <select v-model="info.status">
            <option v-for="(sta, i) in bookStatus" :key="`sta-${i}`" :value="sta">{{sta}}</option>
          </select>
        </div>
        <div v-else-if="fd==='visitDate'">
          <DateInput :style="{width: '240px'}" :defaultValue="moment(info.visitDate).format('YYYY-MM-DD')" @input="info.visitDate=moment($event, 'YYYY-MM-DD').startOf('day').toISOString() "/>
        </div>
        <div v-else-if="fd==='visitTime'">
          <TimeInput :style="{width: '200px'}" :defaultValue="info.visitTime" @input="info.visitTime=$event " :interval="5"/>
        </div>
        <div v-else-if="fd==='agency'">
          <div class="agencyID"><div>{{info.agencyID.name}} <button v-if="info.agencyID.taxID||info.agencyName"
          @click="info.agencyID.taxID=null;info.agencyID.name=null;info.agencyName=null"><svg width="10" height="10" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.6797 1.32004C19.1097 0.750008 18.1859 0.750008 17.6159 1.32004L10.2072 8.72876L2.79815 1.32004C2.22812 0.750008 1.30433 0.750008 0.73429 1.32004C0.164254 1.89008 0.164254 2.81387 0.73429 3.38391L8.1433 10.7929L0.73429 18.2016C0.164254 18.7717 0.164254 19.6955 0.73429 20.2655C1.01916 20.5504 1.39276 20.6928 1.76637 20.6928C2.13997 20.6928 2.51328 20.5504 2.79844 20.2655L10.2075 12.8565L17.6165 20.2655C17.9013 20.5504 18.2749 20.6928 18.6485 20.6928C19.0221 20.6928 19.3954 20.5504 19.6806 20.2655C20.2506 19.6955 20.2506 18.7717 19.6806 18.2016L12.271 10.7926L19.68 3.38362C20.2498 2.81387 20.2498 1.88979 19.6797 1.32004Z" fill="white"/>
          </svg>
          </button></div><button @click="selectAgency=!selectAgency;"></button></div>
        </div>
        <div v-else-if="fd==='groupName'">
          <input type="text" v-model="info.groupName">
        </div>
        <div v-else-if="fd==='orderer'">
          <input type="text" v-model="info.orderer" :style="{width: '145px'}">
        </div>
        <div v-else-if="fd==='ordererTel'">
          <input type="text" v-model="info.ordererTel" :style="{width: '245px'}">
        </div>
        <div v-else-if="fd==='leader'">
          <input type="text" v-model="info.leader" :style="{width: '145px'}">
        </div>
        <div v-else-if="fd==='leaderTel'">
          <input type="text" v-model="info.leaderTel" @change="findLeaderName" :style="{width: '245px'}">
        </div>
        <div v-else-if="fd==='area'">
          <select v-model="info.area"  :style="{width:'145px'}">
            <option :value="null">縣市</option>
            <option v-for="(country, i) in countries" :key="`country-${i}`" :value="country">{{country}}</option>
          </select>
        </div>
        <div v-else-if="fd==='teamAttributes'">
          <select v-model="info.teamAttributes" :style="{width: '245px'}">
            <option v-for="teC in teamAttributes" :key="teC" :value="teC">{{teC}}</option>
          </select>
        </div>
        <div v-else>{{itemSelect[fd]}}</div>
      </div>
      <div class="btns">
        <button class="cancel" @click="edit=false;selectAgency=false">取消</button>
        <button class="confirm" @click="saveInfo">儲存</button>
      </div>
    </editBox>
    <editBoxH label="參觀資訊" v-if="guideEdit" :btnHide="true">
      <div class="infoCol2 infoColEdit">
        <div>預約人數</div>
        <div><input type="text" v-model.number="guide.reserveNum" @change="calculatePrice" :style="{width: '70px', textAlign: 'center', paddingLeft: 0, }"></div>
      </div>
      <div class="infoCol2 infoColEdit">
        <div>票種</div>
      </div>
      <div class="ticketCategory ticketEditBox">
        <div class="ticketEdit">一般<input type="text" v-model.number="guide.ticketCategory.ticket_1"  @change="calculatePriceTicket"></div>
        <div class="ticketEdit">優待<input type="text" v-model.number="guide.ticketCategory.ticket_2"  @change="calculatePriceTicket"></div>
        <div class="ticketEdit">優惠<input type="text" v-model.number="guide.ticketCategory.ticket_3"  @change="calculatePriceTicket"></div>
      </div>
      <hr class="hrgrey">
      <div class="infoCol2 infoColEdit">
        <div>導覽需求</div>
      </div>
      <div class="guide">
        <input type="radio" :value="null" label="待確認" v-model="guide.guideNeeds">
        <input type="radio" :value="false" label="不需要" v-model="guide.guideNeeds">
        <label for="">
          <input type="radio" :value="true" label="需要" v-model="guide.guideNeeds"  @change="calculatePrice" @click="guide.docentCount=guide.docentCount?guide.docentCount:1">
          <div>
            <div>聘 <input type="text" v-model.number="guide.docentCount"  @change="calculatePrice"> 名</div>
            <!-- <div><div :style="{width: '70px', textAlign: 'start'}">導覽員</div> <select v-model="guide.guide"><option :value="null">不指定</option></select></div> -->
            <div v-if="guideTopic"><div :style="{width: '70px', textAlign: 'start'}">導覽主題</div>
              <select v-model="guide.guideRemark">
                <option v-for="(gt, i) in guideTopic" :key="`guideTopic-${i}`" :value="gt">{{gt}}</option>
              </select>
            </div>
          </div>
        </label>
      </div>
      <hr class="hrdeco">
      <div class="guideTotal">
        <span>總人數  <span :style="{color: '#E37878'}">{{guide.reserveNum}}</span>  人</span>
        <span>總金額  <span :style="{color: '#E37878'}">{{guide.totalAmount}}</span>  元</span>
      </div>
      <div class="guideTotal" :style="{marginTop: '10px'}">
        <span></span>
        <span>匯款預付  <span :style="{color: '#E37878', fontSize: '20px'}">{{prePayCalculateEdit}}</span>  元</span>
      </div>
      <div class="btns">
        <button class="cancel" @click="guideEdit=false">取消</button>
        <button class="confirm" @click="saveGuide">儲存</button>
      </div>
    </editBoxH>
    <editBoxH label="參觀資訊" v-else @edit="fnEditGuide">
      <div class="infoCol">
        <div>參觀團數</div>
        <div><span :style="{color: 'var(--color-number)', fontWeight: 900 , fontSize: '20px', marginRight: '30px'}">
          <span v-if="itemSelect.team">{{itemSelect.team.length}}</span>
          <span v-else>{{itemSelect&&itemSelect.teamTemp&&itemSelect.teamTemp.length}}</span>
          </span>團</div>
      </div>
      <div class="infoCol">
        <div>預約人數</div>
        <div><span :style="{color: 'var(--color-number)', fontWeight: 900 , fontSize: '20px', marginRight: '30px'}">{{itemSelect.reserveNum}}</span>人</div>
      </div>
      <div class="infoCol">
        <div>票種</div>
        <div class="ticketCategory" v-if="itemSelect.ticketCategory"><span>一般 {{itemSelect.ticketCategory.ticket_1}}</span> <span>優待 {{itemSelect.ticketCategory.ticket_2}}</span><span>優惠 {{itemSelect.ticketCategory.ticket_3}}</span></div>
      </div>
      <div class="infoCol">
        <div>導覽需求</div>
        <template v-if="itemSelect.guideNeeds">
          <div><span :style="{color: 'var(--color-number)', fontWeight: 900 , fontSize: '20px', marginRight: '20px'}">{{itemSelect.guideNeeds ? itemSelect.docentCount : 0 }}</span> 名</div>
          <div><span :style="{fontSize: '16px'}">{{itemSelect.guideRemark}}</span></div>
        </template>
        <template v-else>
          <div><span :style="{color: itemSelect.guideNeeds===null?'var(--color-number)':'#999999', fontWeight: itemSelect.guideNeeds===null?900:700 , fontSize: '20px', marginRight: '20px'}">{{itemSelect.guideNeeds===null ? '待確認' : '不需要' }}</span></div>
        </template>
      </div>
      <hr class="hrdeco">
      <div class="footCol">總金額  <span :style="{color: 'var(--color-number)'}">{{itemSelect.totalAmount ? itemSelect.totalAmount : 0}}</span>  元</div>
      <div class="footCol">匯款預付<span v-if="!itemSelect.remitAmount">(未付)</span>  <span :style="{color: 'var(--color-number)', fontWeight: 900 , fontSize: '20px'}">{{ itemSelect.remitAmount?itemSelect.remitAmount:prePayCalculate}}</span>  元</div>
    </editBoxH>
    <editBoxH label="匯款資訊" v-if="remitEdit" >
      <div class="infoCol infoColEdit">
        <div>匯款日期</div><div>
          <DateInput :style="{width: '240px'}" :defaultValue="remit.remitDate" @input="remit.remitDate=$event "/>
        </div>
      </div>
      <div class="infoCol infoColEdit">
        <div></div>
        <select v-model="remit.remitTime" :style="{width: '175px'}">
          <option v-for="x in 24" :key="`hour-${x}`" :value="`${(x - 1).toString().padStart(2, '0')}:00`" >{{(x - 1).toString().padStart(2, '0') + ':00'}}</option>
        </select>
      </div>
      <div class="infoCol infoColEdit">
        <div>戶名</div><div><input type="text" v-model="remit.remitName"></div>
      </div>
      <div class="infoCol infoColEdit">
        <div>後五碼</div><div><input type="text" v-model="remit.remit5code"></div>
      </div>
      <div class="infoCol infoColEdit">
        <div>匯款金額</div><div><input type="text" v-model="remit.remitAmount"></div>
      </div>
      <div class="btns">
        <button class="cancel" @click="remitEdit=false">取消</button>
        <button class="confirm" @click="saveRemit">儲存</button>
      </div>
    </editBoxH>
    <editBoxH label="匯款資訊" v-else @edit="editRemit">
      <div class="infoCol">
        <div>匯款日期</div><div v-if="itemSelect.remitTime">{{moment(itemSelect.remitTime).format('YYYY/MM/DD HH:mm')}}</div>
      </div><div class="infoCol">
        <div>戶名</div><div>{{itemSelect.remitName}}</div>
      </div>
      <div class="infoCol">
        <div>後五碼</div><div>{{itemSelect.remit5code}}</div>
      </div>
      <div class="infoCol">
        <div>匯款金額</div><div v-if="itemSelect.remitAmount">
          <span :style="{color: 'var(--color-number)', fontWeight: 900 , fontSize: '20px'}">{{itemSelect.remitAmount}}</span>元</div>
      </div>
      <hr>
      <div class="infofoot">
        <div>對帳人員: {{itemSelect.reconciler&&itemSelect.reconciler.name}}</div>
        <div>{{toDateTime(itemSelect.reconciledTime)}}</div>
      </div>
    </editBoxH>
    <editBoxH label="備註" v-if="editRemark" :btnHide="true">
      <textarea class="remark" v-model="remark" ></textarea>
      <div class="btns">
        <button class="cancel" @click="editRemark=false">取消</button>
        <button class="confirm" @click="saveRemark">儲存</button>
      </div>
    </editBoxH>
    <editBoxH label="備註" v-else @edit="remark=itemSelect.remark;editRemark=true">
      <div class="remark" v-html="itemSelect.remark&&itemSelect.remark.replace(/\n/ig, '<br>')"></div>
    </editBoxH>
    <editBoxH label="客戶備註" :btnHide="true" >
      <p v-html="itemSelect.remarkClient?itemSelect.remarkClient.replaceAll('\n', '<br>'):''"></p>
    </editBoxH>
    <editBoxH :btnHide="true" label="驗證資訊-使用者上傳" v-if="itemSelect.filePath&&itemSelect.filePath.length>0">
      <div v-if="itemSelect.filePath" :style="{display: 'flex', flexDirection: 'column', gap: '10px'}">
        <a class="file" v-for="(file, ig) in itemSelect.filePath" :style="{textAlign: 'start'}"
        :key="`file-${ig}`" :href="`./webapi/images/private/${file}`" download
        >{{file}} <span :style="{color: '#CACACA', fontSize: '14px', marginLeft: '20px'}">(點擊下載)</span></a>
      </div>
    </editBoxH>
    <editBoxH label="業務經辦(員工)" v-if="editSalesman" :btnHide="true">
      <div class="salesman infoCol infoColEdit">
        <div :style="{width: '2.5em', minWidth: '2.5em'}">來源</div>
      <select v-model="source" class="salesman" :style="{width: '180px', marginBlock: 'auto'}">
        <option value=""></option>
        <option v-for="(sman, i) in sources" :key="`sources-${i}`" :value="sman.key">
          {{sman.key}}</option>
      </select>
      </div>
      <div class="salesman infoCol infoColEdit">
        <div :style="{width: '2.5em', minWidth: '2.5em'}">經辦</div>
      <select v-model="salesman" class="salesman" :style="{width: '270px', marginBlock: 'auto'}">
        <option value=""></option>
        <option v-for="(sman, i) in salesmans" :key="`sman-${i}`" :value="sman._id">
          {{sman.department}} | {{sman.post}} | {{sman?.name}}</option>
      </select>
      </div>
      <div class="btns">
        <button class="cancel" @click="editSalesman=false">取消</button>
        <button class="confirm" @click="saveSalesman">儲存</button>
      </div>
    </editBoxH>
    <editBoxH label="業務經辦(員工)" v-else @edit="salesman=itemSelect.salesman&&itemSelect.salesman._id;source=itemSelect.source;editSalesman=true">
      <div class="salesman infoCol">
        <div>業務來源</div>
        <div>{{itemSelect.source}}</div>
      </div>
      <div class="salesman infoCol">
        <div>業務經辦</div>
        <div>{{itemSelect.salesman&&itemSelect.salesman?.name}}</div>
      </div>
      <hr v-if="itemSelect.salesmanAssign&&itemSelect.salesmanAssign[itemSelect.salesmanAssign.length-1]">
      <div class="infofoot" v-if="!showHistory&&itemSelect.salesmanAssign&&itemSelect.salesmanAssign[itemSelect.salesmanAssign.length-1]" @click="showHistory=true">
        <div>操作人員: {{itemSelect.salesmanAssign[itemSelect.salesmanAssign.length-1]&&itemSelect.salesmanAssign[itemSelect.salesmanAssign.length-1].assignBy?.name}}</div>
        <div>{{itemSelect.salesmanAssign[itemSelect.salesmanAssign.length-1]&&toDateTime(itemSelect.salesmanAssign[itemSelect.salesmanAssign.length-1].assignTime)}}</div>
      </div>
      <template v-else>
      <template v-for="(history, h) in itemSelect.salesmanAssign">
      <div class="infofoot"  :key="`history-${h}-0`" @click="showHistory=false">
        <div>來源: {{history.source}}</div>
      </div>
      <div class="infofoot"  :key="`history-${h}-1`" @click="showHistory=false">
        <div>業務: {{history.assignTo&&history.assignTo?.name}}</div>
      </div>
      <div class="infofoot"  :key="`history-${h}-2`" @click="showHistory=false">
        <div>操作: {{history.assignBy&&history.assignBy?.name}}</div>
        <div>{{toDateTime(history.assignTime)}}</div>
      </div>
      </template>
      </template>
    </editBoxH>
    <div v-if="edit&&selectAgency" class="selectAgency" :class="[selectAgency&&itemSelect ? 'slide-in': 'slide-out']">
      <div><input type="text" class="search" v-model="searchAgency"></div>
      <div>
        <div :class="[info.agencyID&&agency._id===info.agencyID._id?'checked':'']" @click="info.agencyID=agency;selectAgency=false" v-for="(agency, i) in agenciesShort" :key="`agency=${i}`">{{agency.name}}</div>
        <div v-if="searchAgency&&searchAgency.length===8" @click="info.agencyID={agencyID: searchAgency, name: searchAgency};selectAgency=false">填入{{searchAgency}}</div>
      </div>
    </div>
    </template>
   <!-- <template v-else-if="infopage==='領隊資訊'&&(itemSelect.status==='已付訂'||itemSelect.status==='已報到')">
     <editBox :height="'80'" :btnHide="true">
        <button class="plusTeam" @click="addTeamR"><iconPlus2/></button>
        <div class="infoCol infoColEdit">
          <div>參觀團數</div>
          <div>
            <span :style="{color: 'var(--color-number)', fontWeight: 900 , fontSize: '20px', marginRight: '30px'}">{{itemSelect.team.length}}</span>團
          </div>
        </div>
        <div class="infoCol" v-for="(team, ti) in itemSelect.team" :index="ti" :key="`team-${ti}`">
          <div>團{{ti+1}}領隊</div><div>{{team.leaderName}}
            <button :style="{backgroundColor: 'transparent', border: 'none'}" @click="deleteTeamR(team._id)"><iconDelete :width="25" :height="25" color2="var(--color-confirm)"/></button></div>
        </div>
      </editBox>
      <template v-for="(team, ti) in itemSelect.team">
        <editTeam :team="team" :index="ti" :key="`team-${ti}`" :itemSelect="itemSelect" @updateItem="$emit('updateItem', $event)"/>
      </template>
    </template>
    <template v-else-if="infopage==='領隊資訊'&&(itemSelect.status!=='已付訂'&&itemSelect.status!=='已報到')">
      <editBox :height="'80'" :btnHide="true">
        <button class="plusTeam" @click="addTeam"><iconPlus2/></button>
        <div class="infoCol infoColEdit" v-if="itemSelect.teamTemp">
          <div>參觀團數</div>
          <div>
            <span :style="{color: 'var(--color-number)', fontWeight: 900 , fontSize: '20px', marginRight: '30px'}">{{itemSelect.teamTemp.length}}</span>團
          </div>
        </div>
        <div class="infoCol" v-for="(team, ti) in itemSelect.teamTemp" :index="ti" :key="`team-${ti}`">
          <div>團{{ti+1}}領隊</div><div>{{team.leaderName}}
            <button :style="{backgroundColor: 'transparent', border: 'none'}" @click="deleteTeam(ti)"><iconDelete :width="25" :height="25" color2="var(--color-confirm)"/></button></div>
        </div>
      </editBox>
      <template v-for="(team, ti) in itemSelect.teamTemp">
        <editTempTeam :team="team" :index="ti" :key="`team-${ti}`" :itemSelect="itemSelect" @updateItem="$emit('updateItem', $event)"/>
      </template>
    </template> -->

    <printTeam :guideTopic="guideTopic" v-if="itemSelect" :item="itemSelect"/>
  </div>
</template>

<script>
import DateInput from '../../components/input/date.vue'
import TimeInput from '../../components/input/time.vue'
import printTeam from './printTeam.vue'
import { postapi, getapi, deleteapi } from '../../store/fetch'
import editBox from '../../components/editBox'
import editBoxH from '../../components/editBoxWithHeader'
export default {
  components: {
    printTeam,
    editBox,
    editBoxH,
    DateInput,
    TimeInput
  },
  data () {
    return {
      showHistory: false,
      zh: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
      infopage: '預約資訊',
      edit: false,
      guideEdit: false,
      remitEdit: false,
      feeSplittingEdit: false,
      editSalesman: false,
      editRemark: false,
      guideTopic: [],
      tickets: [],
      Prepaid: 0,
      PrepaidDocent: 0,
      salesmans: [],
      salesman: null,
      source: null,
      remark: null,
      searchAgency: null,
      agenciesShort: [],
      selectAgency: false,
      disabledDates: [],
      bookStatus: [],
      guide: {
        reserveNum: null,
        ticketCategory: {
          ticket_1: 0,
          ticket_2: 0,
          ticket_3: 0
        },
        guideNeeds: null,
        docentCount: 0,
        guideRemark: '綜合導覽',
        totalAmount: 0
      },
      teamEdit: [],
      remit: {
        remitTime: null,
        remitDate: null,
        remit5code: null,
        remitName: null,
        remitAmount: null
      },
      info: {
        status: null,
        visitDate: null,
        visitTime: null,
        orderer: null,
        ordererTel: null,
        agencyID: null,
        agencyName: null,
        leaderName: null,
        leaderID: null,
        groupName: null
      },
      feeSplitting: {
        ticket: {
          agency: 80,
          leader: 20
        },
        consume: {
          agency: 20,
          leader: 80
        }
      },
      fieldsDetial: {
        status: '預約狀態',
        visitDate: '參觀日期',
        visitTime: '參觀時段',
        orderer: '預約人',
        ordererTel: '預約電話',
        agency: '代理商',
        agencyID: '統一編號',
        leader: '領隊',
        leaderTel: '領隊電話',
        groupName: '團體名稱',
        teamAttributes: '團體屬性',
        area: '地區'
      },
      countries: [],
      fieldsDetial2: [
        '預約人數',
        '導覽需求',
        '票種',
        '總金額',
        '匯款預付'
      ],
      fieldsDetial3: [
        '團體ID',
        '團體名稱',
        '領隊名稱',
        '領隊電話',
        '團體人數'
      ],
      fieldsDetial4: [
        '團體名稱',
        '領隊名稱',
        '領隊電話',
        '團體人數'
      ]
    }
  },
  computed: {
    prePayCalculate () {
      let c = 0
      // console.log(this.itemSelect.guideNeeds, this.itemSelect.docentCount, this.PrepaidDocent, this.Prepaid)
      if (this.itemSelect.guideNeeds === true && this.itemSelect.docentCount) {
        c = c + this.PrepaidDocent * this.itemSelect.docentCount
      } else if (this.itemSelect.guideNeeds === true && this.itemSelect.docentCount) {
        c = c + this.PrepaidDocent * this.itemSelect.docentCount
      }
      c = c + this.Prepaid
      return c
    },
    prePayCalculateEdit () {
      let c = 0
      // console.log(this.guide.guideNeeds, this.guide.docentCount, this.PrepaidDocent, this.Prepaid)
      if (this.guide.guideNeeds && this.guide.docentCount) {
        c = c + this.PrepaidDocent * this.guide.docentCount
      }
      c = c + this.Prepaid
      return c
    }
  },
  async mounted () {
    this.countries = await getapi('selections/country')
  },
  created () {
    this.getStatusmap()
    this.getagenciesShort()
    this.getSalesman()
    this.getTicket()
  },
  watch: {
    'itemSelect._id' () {
      this.edit = false
      this.guideEdit = false
      this.remitEdit = false
      this.feeSplittingEdit = false
      this.editRemark = false
      this.editSalesman = false
      this.teamEdit = this.itemSelect && this.itemSelect.teamTemp ? this.itemSelect.teamTemp.map(e => false) : []
    },
    searchAgency () {
      this.getagenciesShort()
    },
    'guide.reserveNum' () {
      this.calculatePrice()
    },
    'guide.docentCount' () {
      this.calculatePrice()
    },
    'guide.guideNeeds' () {
      this.calculatePrice()
    }
  },
  methods: {
    async findLeaderName () {
      if (this.info.leader) {} else {
        if (this.info.leaderTel.length > 8) {
          const u = await getapi(`users/leader/tel?tel=${this.info.leaderTel}`)
          if (u && u.length > 0) {
            console.log('user find ', u[0].name)
            this.info = {
              ...this.info, leader: u[0].name
            }
          }
        }
      }
    },
    async deleteTeamR (tid) {
      const r = await deleteapi(`teams/${tid}`)
      if (r) {
        const newdata = await getapi(`visitbooking/${this.itemSelect._id}`)
        this.$emit('updateItem', newdata)
      }
    },
    async addTeamR () {
      const r = await postapi(`teams/add/${this.itemSelect._id}`)
      if (r) {
        const newdata = await getapi(`visitbooking/${this.itemSelect._id}`)
        this.$emit('updateItem', newdata)
      }
    },
    async deleteTeam (index) {
      const r = await deleteapi(`visitbooking/${this.itemSelect._id}/${index}`)
      if (r) {
        this.$emit('updateItem', r)
      }
    },
    async addTeam () {
      const r = await postapi(`visitbooking/${this.itemSelect._id}/addteam`)
      if (r) {
        this.$emit('updateItem', r)
      }
    },
    calculatePriceTicket () {
      const tks = {
        ticket_1: this.guide.ticketCategory && this.guide.ticketCategory.ticket_1 ? this.guide.ticketCategory.ticket_1 : 0,
        ticket_2: this.guide.ticketCategory && this.guide.ticketCategory.ticket_2 ? this.guide.ticketCategory.ticket_2 : 0,
        ticket_3: this.guide.ticketCategory && this.guide.ticketCategory.ticket_3 ? this.guide.ticketCategory.ticket_3 : 0
      }
      this.guide.reserveNum = tks.ticket_1 + tks.ticket_2 + tks.ticket_3
      // console.log('-------- debug ----------', this.tickets)
      const price = this.tickets.map(e => {
        // console.log(e.price * (tks[e.ref_name] ? tks[e.ref_name] : 0), e.ref_name, e.price, tks[e.ref_name])
        return e.price * (tks[e.ref_name] ? tks[e.ref_name] : 0)
      }).reduce((a, b) => a + b, 0)
      const priceGuide = !this.guide.guideNeeds ? 0 : (this.guide.docentCount ? this.guide.docentCount * this.PrepaidDocent : this.PrepaidDocent)
      // console.log(price, priceGuide)
      this.guide.totalAmount = price + priceGuide
    },
    calculatePrice () {
      const number = this.guide.reserveNum ? this.guide.reserveNum : 0
      const tks = {
        ticket_1: this.guide.ticketCategory && this.guide.ticketCategory.ticket_1 ? this.guide.ticketCategory.ticket_1 : 0,
        ticket_2: this.guide.ticketCategory && this.guide.ticketCategory.ticket_2 ? this.guide.ticketCategory.ticket_2 : 0,
        ticket_3: this.guide.ticketCategory && this.guide.ticketCategory.ticket_3 ? this.guide.ticketCategory.ticket_3 : 0
      }
      this.guide.ticketCategory.ticket_1 = number - tks.ticket_2 - tks.ticket_3
      const price = this.tickets.map(e => {
        // console.log(e.price * (tks[e.ref_name] ? tks[e.ref_name] : 0), e.ref_name, e.price, tks[e.ref_name])
        return e.price * (tks[e.ref_name] ? tks[e.ref_name] : 0)
      }).reduce((a, b) => a + b, 0)
      const priceGuide = !this.guide.guideNeeds ? 0 : (this.guide.docentCount ? this.guide.docentCount * this.PrepaidDocent : this.PrepaidDocent)
      // console.log(price, priceGuide)
      this.guide.totalAmount = price + priceGuide
    },
    async getTicket () {
      const tickets = await getapi('products/tickets/refs')
      this.tickets = tickets
      const PrepaidDocent = await getapi('selections/PrepaidDocent')
      this.PrepaidDocent = PrepaidDocent ? parseInt(PrepaidDocent) : 0
      const Prepaid = await getapi('selections/Prepaid')
      this.Prepaid = Prepaid ? parseInt(Prepaid) : 0
    },
    fnEditGuide () {
      this.guide.reserveNum = this.itemSelect.reserveNum
      this.guide.guideNeeds = this.itemSelect.guideNeeds
      this.guide.totalAmount = this.itemSelect.totalAmount
      this.guide.docentCount = this.itemSelect.docentCount ? this.itemSelect.docentCount : (this.itemSelect?.teamTemp?.length || this.itemSelect?.team?.length)
      this.guide.ticketCategory.ticket_1 = this.itemSelect.ticketCategory ? this.itemSelect.ticketCategory.ticket_1 : 0
      this.guide.ticketCategory.ticket_2 = this.itemSelect.ticketCategory ? this.itemSelect.ticketCategory.ticket_2 : 0
      this.guide.ticketCategory.ticket_3 = this.itemSelect.ticketCategory ? this.itemSelect.ticketCategory.ticket_3 : 0
      this.guideEdit = true
    },
    async saveGuide () {
      const r = await postapi(`visitbooking/v2/${this.itemSelect._id}`, {
        ...this.guide
      })
      if (r) {
        this.$emit('updateItem', r)
        this.guideEdit = false
      }
    },
    async saveSalesman () {
      if ((!this.itemSelect.salesman || this.salesman !== this.itemSelect.salesman._id) || (this.itemSelect.source !== this.source)) {
        const r = await postapi(`visitbooking/v2/${this.itemSelect._id}`, { salesman: this.salesman, source: this.source })
        if (r) {
          this.$emit('updateItem', r)
          this.editSalesman = false
        }
      } else {
        this.editSalesman = false
      }
    },
    async getSalesman () {
      const salesmans = await getapi('users/local/short')
      this.salesmans = salesmans
    },
    async saveRemark () {
      if (this.remark !== this.itemSelect.remark) {
        const r = await postapi(`visitbooking/v2/${this.itemSelect._id}`, { remark: this.remark })
        if (r) {
          this.editRemark = false
          this.$emit('updateItem', r)
        }
      } else {
        this.editRemark = false
      }
    },
    async getagenciesShort () {
      this.agenciesShort = await getapi(`agencies/short${this.searchAgency ? `?search=${this.searchAgency}` : ''}`)
    },
    async getStatusmap () {
      const bookStatus = await getapi('selections/bookStatus')
      this.bookStatus = bookStatus
      this.disabledDates = await getapi('selections/bookTime')
      this.guideTopic = await getapi('selections/guideTopic')
    },
    async saveInfo () {
      this.selectAgency = false
      // console.log(this.info)
      const data = {}
      if (this.info.leader !== this.itemSelect.leader) {
        data.leader = this.info.leader
      }
      if (this.info.leaderTel !== this.itemSelect.leaderTel) {
        data.leaderTel = this.info.leaderTel
      }
      if (this.info.teamAttributes !== this.itemSelect.teamAttributes) {
        data.teamAttributes = this.info.teamAttributes
      }
      if (this.info.status !== this.itemSelect.status) {
        data.status = this.info.status
      }
      if (this.info.visitDate !== this.itemSelect.visitDate) {
        data.visitDate = this.moment(this.info.visitDate).toDate()
      }
      if (this.info.area !== this.itemSelect.area) {
        data.area = this.info.area
      }
      if (this.info.visitTime !== this.itemSelect.visitTime) {
        data.visitTime = this.info.visitTime
      }
      if (this.info.orderer !== this.itemSelect.orderer) {
        data.orderer = this.info.orderer
      }
      if (this.info.ordererTel !== this.itemSelect.ordererTel) {
        data.ordererTel = this.info.ordererTel
      }
      if (this.info.agencyID.taxID !== this.itemSelect.agencyID) {
        data.agencyID = this.info.agencyID.taxID
      }
      if (this.info.leader !== this.itemSelect) {
        data.leader = this.info.leader
      }
      if (this.info.groupName !== this.itemSelect['團體名稱']) {
        data.groupName = this.info.groupName
      }
      // console.log(data)
      if (Object.keys(data).length > 0) {
        const r = await postapi(`visitbooking/v2/${this.itemSelect._id}`, data)
        if (r) {
          this.$emit('updateItem', r)
          this.edit = false
        }
      } else {
        this.edit = false
      }
    },
    editInfo () {
      this.info.area = this.itemSelect.area
      this.info.status = this.itemSelect.status
      this.info.teamAttributes = this.itemSelect.teamAttributes
      this.info.visitDate = this.itemSelect.visitDate ? this.toDate(this.itemSelect.visitDate) : null
      this.info.visitTime = this.itemSelect.visitTime
      this.info.orderer = this.itemSelect.orderer
      this.info.ordererTel = this.itemSelect.ordererTel
      this.info.agencyID = {
        taxID: this.itemSelect.agencyID,
        name: this.itemSelect?.agency?.name
      }
      // const team = this.itemSelect.teamTemp ? this.itemSelect.teamTemp : this.itemSelect.team
      this.info.leader = this.itemSelect.leader // ? this.itemSelect.leader : (team[0].leaderName ? String(team[0].leaderName) : null)
      this.info.leaderTel = this.itemSelect.leaderTel // ? this.itemSelect.leaderTel : (team[0]?.leaderMobile ? String(team[0]?.leaderMobile) : null)
      this.info.groupName = this.itemSelect.groupName
      this.edit = true
    },
    async saveRemit () {
      if (this.remit.remit5code || this.remit.remitName) {
        const remit = {
          remit5code: this.remit.remit5code,
          remitName: this.remit.remitName,
          remitTime: this.moment(`${this.remit.remitDate} ${this.remit.remitTime}`).toDate(),
          remitAmount: this.remit.remitAmount
        }
        if (this.itemSelect.status === '預約中') {
          remit.status = '通知付訂'
        }
        // console.log(remit, `${this.remit.remitDate} ${this.remit.remitTime}`)
        const r = await postapi(`visitbooking/v2/${this.itemSelect._id}`, remit)
        if (r) {
          this.$emit('updateItem', r)
          this.remitEdit = false
        }
      } else {
        this.remitEdit = false
      }
    },
    editRemit () {
      this.remit.remit5code = this.itemSelect.remit5code
      this.remit.remitAmount = this.itemSelect.remitAmount
      this.remit.remitTime = this.itemSelect.remitTime ? this.moment(this.itemSelect.remitTime).format('HH:mm') : '00:00'
      this.remit.remitDate = this.itemSelect.remitTime ? this.moment(this.itemSelect.remitTime).format('YYYY-MM-DD') : this.moment().format('YYYY-MM-DD')
      this.remitEdit = true
    }
  },
  props: ['itemSelect', 'teamAttributes', 'sources']
}
</script>
<style lang="scss" scoped>
hr {
  width: 100%;
  height: 1px;
  background-color: #CACACA;
  margin-block: 10px;
}
.pages {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  flex-direction: row;
  gap: 15px;
}
input[type=radio].page {
  width: 120px;
  height: 40px;
  appearance: none;
  border: 1px solid var(--color-pri);
  border-radius: 20px;
  background-color: #FFFFFF;
  color: var(--color-pri);
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:checked {
    background-color: var(--color-pri);
    color: #FFFFFF;
  }
  &::before {
    content: attr(value);
  }
}
.guideTotal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: var(--color-letter);
  gap: 10px;
  padding-inline: 20px;
  margin-bottom: 10px;
}
.infoCol2 {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  text-align: right;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 27px;
  height: 40px;
  &>div:nth-child(1) {
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  &>div:nth-child(2) {
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

}
.ticketEditBox {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  .ticketEdit {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    input {
      width: 50px;
      height: 25px;
      border: 1px solid #C4C4C4;
      box-sizing: border-box;
      border-radius: 3px;
      font-family: Noto Sans TC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      letter-spacing: 0.1em;
      text-align: center;
    }
  }
}
.guide {
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  input[type=radio] {
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  &::before {
    display: inline-block;
    box-sizing: border-box;
    content: '';
    width: 24px;
    height: 24px;
    border-radius: 12px;
    border: 2px solid var(--color-pri);
  }
  &:checked::before {
    background-image: url(/checked.svg);
    background-color: var(--color-checked);
    background-position: center;
  }
  &::after {
    content: attr(label);
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: var(--color-letter);
  }
  }
  label {
    display: flex;
    align-items: flex-start;
    margin-top: 5px;
    justify-content: flex-start;
    &>div {
      display: flex;
      flex-direction: column;
      padding-left: 20px;
      gap: 10px;
      &>div{
        display: flex;
        align-items: center;
        height: 30px;
      }
    }
    select {
      width: 140px;
      height: 30px;
      border: 1px solid #C4C4C4;
      box-sizing: border-box;
      border-radius: 3px;
      font-family: Noto Sans TC;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      letter-spacing: 0.1em;
      color: var(--color-letter);
      padding-inline: 12px;
    }
    input[type=text] {
      margin-inline: 10px;
      width: 50px;
      height: 25px;
      border: 1px solid #C4C4C4;
      box-sizing: border-box;
      border-radius: 3px;
      font-family: Noto Sans TC;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      letter-spacing: 0.1em;
      text-align: center;
    }
  }
}
.feeSplitting:nth-child(2) {
  margin-bottom: 12px;
}
select.salesman {
  width: fill;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 3px;
  justify-self: flex-start;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  padding-inline: 12px;
  margin-bottom: 12px;
}
div.salesman {
  width: 100%;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  padding-inline: 10px;
}
textarea.remark {
  width: 100%;
  height: fit-content;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  text-align: start;
  color: var(--color-letter);
  min-height: 200px;
  border: 1px solid #C4C4C4;
  margin-bottom: 10px;
}
.slide-in {
    animation: slide-in 0.5s forwards;
    -webkit-animation: slide-in 0.5s forwards;
}

.slide-out {
    animation: slide-out 0.5s forwards;
    -webkit-animation: slide-out 0.5s forwards;
}

@keyframes slide-in {
    100% { transform: translateX(0%); }
}

@-webkit-keyframes slide-in {
    100% { -webkit-transform: translateX(0%); }
}

@keyframes slide-out {
    0% { transform: translateX(0%); }
    100% { transform: translateX(calc(100% + 15px));  }
}

@-webkit-keyframes slide-out {
    0% { -webkit-transform: translateX(0%); }
    100% { -webkit-transform: translateX(calc(100% + 15px)); }
}
.search {
  width: 300px;
  height: 40px;
  box-sizing: border-box;
  background-image: url(/search.svg);
  background-position: calc(100% - 10px) 10px;
  background-repeat: no-repeat;
  border-radius: 3px;
  border: 1px solid #C4C4C4;
  text-indent: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  padding-top: 8px;
  &::placeholder {
    color: var(--color-border);
  }
}
.selectAgency {
  position: fixed;
  left: -374px;
  bottom: 47px;
  z-index: -1;
  display: flex!important;
  flex-direction: column;
  width: 370px;
  min-height: 550px;
  max-height: 550px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px 0px 0px 10px;
  background-color: #FFFFFF;
  &>div:nth-child(1) {
    width: 100%;
    padding-inline: 36px;
    padding-top: 24px;
    padding-bottom: 10px;
    height: fit-content;
  }
  &>div:nth-child(2) {
    overflow-y: scroll;
    margin-inline: 16px;
    padding-inline: 19px;
    margin-bottom: 10px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    &::-webkit-scrollbar {
      height: 7px;
      width: 7px;
      background-color: #F5F5F5;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 20px;
      box-shadow: inset 0 0 6px #0000004d;
      background-color: var(--color-pri);
    }
    &::-webkit-scrollbar-track {
      border: none;
      border-radius: 20px;
      background-color: #d8d8d8;
      border: 2px solid #FFFFFF!important;
    }
    &>div {
      width: 100%;
      font-family: Noto Sans TC;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      letter-spacing: 0.1em;
      color: var(--color-letter);
      height: 50px;
      min-height: 50px;
      text-align: start;
      display: flex;
      align-items: center;
      &.checked {
        background-color: #E9F5FC;
      }
      &:hover {
        background-color: #E9F5FC;
      }
    }
  }
}
.agencyID {
  display: flex;
  &>div {
    box-sizing: border-box;
    width: 200px;
    height: 40px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    padding-inline: 12px;
    text-align: start;
    white-space: nowrap;
    flex-wrap: nowrap;
    overflow-x: hidden;
    padding-right: 23px;
    position: relative;
    button {
      width: 20px;
      height: 20px;
      background-color: #B8B8B8;
      position: absolute;
      right: 3px;
      border: none;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      &:hover {
        background-color: #C4C4C4;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
      }
    }
  }
  &>button {
    width: 40px;
    height: 40px;
    background-color: var(--color-checked);
    mask-image: url(/selectbox.svg);
    mask-size: cibntain;
    mask-position: center;
    mask-repeat: no-repeat;
    border: none;
  }
}
.預約狀態 {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  letter-spacing: 0.1em;
  &.已付訂 {
    color: var(--已付訂);
  }
  &.通知付訂 {
    color: var(--通知付訂);
  }
  &.預約中 {
    color: var(--預約中);
  }
  &.已取消 {
    color: var(--已取消);
  }
  &.已報到 {
    color: var(--已報到);
  }

}
.ticketCategory {
  display: flex;
  gap: 14px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
}
.feeSplitting {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  text-align: right;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 27px;
  height: 42px;
  height: 45px;
  &>div:nth-child(1) {
    width: 75px;
    min-width: 75px;
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  &>div:nth-child(2) {
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  &::before {
    width: 64px!important;
  }
  &>div {
    gap: 20px;
  }
  &>div>div {
    display: flex;
    align-items: center;
    gap: 3px;
  }
  input {
    height: 30px;
    border: 1px solid #C4C4C4;
    box-sizing: border-box;
    border-radius: 3px;
    text-align: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    text-align: center;
    color: var(--color-letter);
  }
}
.mb20 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
  overflow-y: auto;
}
.remark {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  text-align: start;
  color: var(--color-letter);
}
.hrdeco {
  height: 12px;
  background-color: var(--color-pri);
  border-inline: 10px solid var(--color-pri);
  border-block: 5.5px solid #FFFFFF;
  width: 100%;
  margin-block: 10px;
}
.infofoot {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #999999;
}
.footCol {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: end;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  height: 32px;
}
.infoCol {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  text-align: right;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 27px;
  min-height: 40px;
  height: fit-content;
  &>div:nth-child(1) {
    width: 90px;
    min-width: 90px;
    display: inline-flex;
    justify-content: flex-end;
    align-items: flex-start;
  }
  &>div:nth-child(2) {
    text-align: start;
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
</style>
<style lang="scss" scoped>
.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;

  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
</style>
<style lang="scss" scoped>
.infoColEdit {
  height: 60px;
  box-sizing: border-box;
  &>:nth-child(2)>input[type=text], &>:nth-child(2)>select {
    height: 40px;
    box-sizing: border-box;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    padding-left: 14px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    box-sizing: border-box;
  }
  &>:nth-child(2)>input[type=text] {
    color: var(--color-letter);
  }
  &>:nth-child(2)>select {
    color: var(--color-checked);
  }
  input[type=radio] {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    appearance: none;
    background-color: #B8B8B8;
    color: #FFFFFF;
    &::after {
      content: attr(value);
    }
    border: none;
    border-radius: 3px;
    font-size: 16px;
    &:checked {
      background-color: var(--color-checked);
    }
  }
  select {
    border: 1px solid #C4C4C4;
    box-sizing: border-box;
    border-radius: 3px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #517FA4;
    height: 40px;
    padding-inline: 12px;
  }
}
</style>
<style lang="scss">
.plusTeam {
  padding: 0;
  margin: 0;
  height: 50px;
  display: flex;
  align-items: center;
  width: 50px;
  position: absolute;
  top: 10px;
  right: 5px;
  background-color: transparent;
  border: none;
}
</style>
